export const fieldShellSx = {
    display: 'grid',
    gridTemplateColumns: '1fr auto 1fr',
    alignItems: 'center',
    width: '100%',
    height: '34px',
    border: 1,
    borderColor: 'divider',
    borderRadius: 1,
    px: 1,
    columnGap: 0.5,
    bgcolor: 'background.paper',
    '&:focus-within': { borderColor: 'primary.main' },
} as const

export const typeSelectSx = {
    width: 'fit-content',
    maxWidth: '100%',
    borderRadius: 1,
    cursor: 'pointer',
    px: 0.5,
    py: 0,
    m: 0,
    minHeight: 'unset',
    bgcolor: 'transparent',
    '&:hover': { bgcolor: 'transparent' },
    '&.Mui-focused': { bgcolor: 'transparent' },
    '&.MuiInputBase-root.Mui-focused': { bgcolor: 'transparent' },
    '& .MuiSelect-select': {
        py: 0,
        pl: 0,
        pr: '0 !important',
        minHeight: 'unset',
        display: 'inline-flex',
        alignItems: 'center',
        width: 'auto',
        bgcolor: 'transparent',
    },
    '& .MuiSelect-icon': { display: 'none' },
} as const

export const typeSelectWrapSx = {
    display: 'inline-flex',
    alignSelf: 'flex-start',
    borderRadius: 1,
    transition: 'background-color 0.15s ease',
    '&:hover': { bgcolor: 'action.hover' },
} as const

export const typeLabelTypographySx = {
    textTransform: 'uppercase',
    lineHeight: '20px',
} as const

export const fieldArrowSx = {
    fontSize: '0.875rem',
    color: 'text.disabled',
    justifySelf: 'center',
    lineHeight: 1,
    userSelect: 'none',
} as const

export const slTargetClearBtnSx = {
    p: 0,
    zIndex: 2,
    mr: 0.25,
    ml: 0.25,
    width: 28,
    height: 28,
    border: 'none',
    borderRadius: 1,
    '&:hover': { backgroundColor: 'action.hover' },
} as const
